import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExecutiveHighlightService {
  private highlightedIndexSubject = new BehaviorSubject<number | null>(null);
  private highlightedRoleSubject = new BehaviorSubject<number | null>(null);

  highlightedIndex$ = this.highlightedIndexSubject.asObservable();
  highlightedRole$ = this.highlightedRoleSubject.asObservable();

  setHighlight(index: number, role: number) {
    this.highlightedIndexSubject.next(index);
    this.highlightedRoleSubject.next(role);
    localStorage.setItem('highlightedExecutiveIndex', index.toString());
    localStorage.setItem('highlightedExecutiveRole', role.toString());
  }

  constructor() {
    const idx = localStorage.getItem('highlightedExecutiveIndex');
    const role = localStorage.getItem('highlightedExecutiveRole');
    if (idx !== null) this.highlightedIndexSubject.next(Number(idx));
    if (role !== null) this.highlightedRoleSubject.next(Number(role));
  }

  getHighlightedIndex(): number | null {
    return this.highlightedIndexSubject.value;
  }
  getHighlightedRole(): number | null {
    return this.highlightedRoleSubject.value;
  }
}